import React, { Component } from 'react';
import './App.css';
import baebbleLogo from '../public/baebble.png'
import classNames from 'classnames';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isHovered: false,
    }
  }

  render() {
    return (
      <div className="baebble">
        <div className="center">
          <img className="logo" 
            src={baebbleLogo} 
            alt="Baebble" 
            onMouseOver={() => {this.setState({isHovered: true})}} 
            onMouseLeave={() => {this.setState({isHovered: false})}} />
          <div className={classNames("coming-soon", {"fade-in": this.state.isHovered})}>coming soon</div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx